export default __webpack_public_path__ + "static/SRUS RTL4 - Product Specifications & Technical Data-45d5015814d96825b34be5827a823d19.pdf";